import { render, staticRenderFns } from "./DictMultipleSelect.vue?vue&type=template&id=d3ca34b0&"
import script from "./DictMultipleSelect.vue?vue&type=script&lang=js&"
export * from "./DictMultipleSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports